import { z } from "zod";

export const insuranceSchema = z.object({
  id: z.string().optional(),

  localId: z.string().optional(),

  coverage_type: z.string().nullable().optional(),

  government_scheme: z.string().nullable().optional(),

  government_scheme_other: z.string().trim().optional(),

  insurance_provider_name: z.string().trim().optional(),

  tpa_name: z.string().trim().optional(),

  policy_or_card_number: z.string().trim().optional(),

  policy_validity_date: z.string().optional(),

  pre_authorization_required: z.boolean().nullable().optional(),

  insurance_card_letter_file: z.any().optional(),

  insurance_card_letter_pending: z.any().optional(),
});

export type InsuranceFormValues = z.infer<typeof insuranceSchema>;
